// removed by extract-text-webpack-plugin
module.exports = {"ellipsis":"antd-pro-ellipsis-ellipsis","lines":"antd-pro-ellipsis-lines","shadow":"antd-pro-ellipsis-shadow","lineClamp":"antd-pro-ellipsis-lineClamp"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Ellipsis/index.less
// module id = 1151
// module chunks = 0